var chunkToChildrenMap = {
	"1003": [
		9520,
		1982
	],
	"1189": [
		9520,
		1982
	],
	"6642": [
		9520,
		1982
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };